export const isBase64 = (str: string): boolean => {
  if (typeof str !== 'string') return false;
  const len = str.length;
  // Base64 string length must be a multiple of 4
  if (len % 4 !== 0) return false;
  // Only valid Base64 characters and up to two padding '='
  return /^[A-Za-z0-9+/]+={0,2}$/.test(str);
};

export const fromBase64 = (base64: string): string =>
  Buffer.from(base64, 'base64').toString('utf8');

/**
 * Encodes a string to base64. Unlike the global `btoa`, this is UTF-8 safe —
 * `btoa` only accepts Latin-1 and throws `InvalidCharacterError` on characters
 * outside that range (e.g. "š" in "Škoda"). Works in both Node and the browser,
 * so it is safe to call from server and client components alike.
 *
 * Output is identical to `btoa` for pure-ASCII input, so it is a drop-in
 * replacement that does not change existing base64 keys.
 */
export const toBase64 = (str: string): string =>
  btoa(String.fromCharCode(...new TextEncoder().encode(str)));
